module.exports = __webpack_public_path__ + "img/13.25da1dc7.png";